import { useState, useCallback } from "react";
import useGetUpcomingReminders from "../../../reminders/api/useGetUpcomingReminders";
import { flattenUniquePages, getId } from "../../../../utils/pagination";

export default function useUpcomingRemindersDrawer() {
  const [isOpen, setIsOpen] = useState(false);

  // Only fetch once the drawer has been opened.
  const { data, isLoading, hasNextPage, isFetchingNextPage, isFetchNextPageError, fetchNextPage } = useGetUpcomingReminders({ enabled: isOpen });

  function handleOpen() {
    setIsOpen(true);
  }

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  function handleLoadMore() {
    fetchNextPage();
  }

  return {
    isOpen,
    handleOpen,
    handleClose,
    reminders: flattenUniquePages(data?.pages, getId),
    hasMore: hasNextPage,
    isLoading,
    isLoadingMore: isFetchingNextPage,
    isLoadMoreError: isFetchNextPageError,
    handleLoadMore,
  };
}
